import { render, staticRenderFns } from "./classTest.vue?vue&type=template&id=c3e2e60e&scoped=true"
import script from "./classTest.vue?vue&type=script&lang=js"
export * from "./classTest.vue?vue&type=script&lang=js"
import style0 from "./classTest.vue?vue&type=style&index=0&id=c3e2e60e&prod&lang=scss"
import style1 from "./classTest.vue?vue&type=style&index=1&id=c3e2e60e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e2e60e",
  null
  
)

export default component.exports